export const CATEGORY_STORAGE_ID = 'categories';
